import Vue from 'vue';
import VueRouter from 'vue-router'
import login from '@/views/login.vue'
import NotFound from '@/views/404.vue'
import index from '@/views/index.vue'
import apply from '@/views/apply/applyList.vue'
import line from '@/views/line/lineList.vue'
import lineUpdate from '@/views/line/lineUpdate.vue'
import users from '@/views/users/users.vue'
import info from '@/views/info/infoList.vue'
import applyForLine from '@/views/apply/applyForLine.vue'
import applyForEquip from '@/views/apply/applyForEquip.vue'
Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'hash',
    routes: [
    {
        path:'/',
        redirect: '/index'
    },

    {
        path: '/index',
        component: index,
        name: 'index',
        redirect:"/lineList",
        children:[
            {
                path: '/networkList',
                component: () => import('@/views/network/networkList'),
                name: 'network'
            },
            {
                path:"/networkUpdate",
                name:"networkUpdate",
                component:() => import('@/views/network/networkUpdate')
            },
            {
                path: '/lineList',
                component: line,
                name: 'line',
            },
            {
                path: '/addLine',
                component: () => import('@/views/line/addLine'),
                name: 'addLine'
            },
            {
                path: '/lineCity',
                component: () => import('@/views/line/lineCity'),
                name: 'lineCity'
            },
            {
                path: '/cityList',
                component: () => import('@/views/line/cityList'),
                name: 'cityList'
            },
            {
                path: '/addCity',
                component: () => import('@/views/line/addCity'),
                name: 'addCity'
            },
            {
                path: '/articleList',
                component: () => import('@/views/article/articleList'),
                name: 'articleList',
            },
            {
                path: '/articleUpdate',
                component: () => import('@/views/article/articleUpdate'),
                name: 'articleUpdate'
            },
            {
                path: '/freeMarketList',
                component: () => import('@/views/freeMarket/freeMarketList'),
                name: 'freeMarketList',
            },
            {
                path: '/freeMarketUpdate',
                component: () => import('@/views/freeMarket/freeMarketUpdate'),
                name: 'freeMarketUpdate'
            },
            {
                path: '/employList',
                component: () => import('@/views/employ/employList'),
                name: 'employtList',
            },
            {
                path: '/employUpdate',
                component: () => import('@/views/employ/employUpdate'),
                name: 'employUpdate'
            },
            {
                path: '/networkList',
                component: () => import('@/views/network/networkList'),
                name: 'networkList',
            },
            {
                path: '/networkUpdate',
                component: () => import('@/views/network/networkUpdate'),
                name: 'networkUpdate'
            },
            {
                path: '/goodsList',
                component: () => import('@/views/goods/goodsList'),
                name: 'goodsList',
            },
            {
                path: '/goodsUpdate',
                component: () => import('@/views/goods/goodsUpdate'),
                name: 'goodsUpdate'
            },
            {
                path: '/goodsOrderList',
                component: () => import('@/views/goods/goodsOrderList'),
                name: 'goodsOrderList',
            },
            {
                path: '/goodsOrderUpdate',
                component: () => import('@/views/goods/goodsOrderUpdate'),
                name: 'goodsOrderUpdate'
            },
            {
                path: '/info',
                component: info,
                name: 'info',
            },
            {
                path: '/joinUs',
                component: () => import('@/views/joinus/joinUsList'),
                name: 'joinUs',
            },
            {
                path: '/userList',
                component: () => import('@/views/users/users'),
                name: 'userList',
            },{
                path:"/lunbotu",
                name:"lunbotu",
                component: () => import('@/views/index/indexImg'),
            }
        ]
    },
    {
        path: '/login',
        component: login,
        name: 'login',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '404',
        hidden: true
    },
    
]});

router.beforeEach((to,from,next)=>{
   
  if(localStorage.getItem("hasLogin")){
      next();
  }else{
    if(to.name!='login'){
        next({
          name: 'login'
        });
    }else{
      next();
    }
  }
});
export default router;